<template>
  <!--
    WHAT — Metric Insight detail tab "Visualization". Configures how the insight
      is drawn: viz type (chart_v5 / table / sankey / heatmap / pie), the
      field-mapping viz_config, layout width, display_order, and insight_type
      (metric_insight vs task_insight). Wraps the reused-v1 InsightVizPanel,
      fed the LIVE output columns of the fact DA(s).

    CONTRACT — reads record.insight_type / viz_type / viz_config / layout /
      display_order into a local `viz` object. Emits patch({ insight_type,
      viz_type, viz_config, layout, display_order }) via a deep watcher on `viz`
      (layout defaults to { width: 'full' }, display_order to 0). Output columns
      resolved from GET /api/metrics/workflow-columns/{workflow_id}/ per studio_config step.

    NOTES — hydrating guard: loadColumns() runs in async mounted() and `hydrating`
      clears only on the next $nextTick, so the initial deep-watch fire is
      suppressed. Wraps a v1 panel (InsightVizPanel). selfChrome: true — the panel
      draws its own card, so ArtifactDetail renders this body bare.
  -->
  <!-- Metric Insight "Visualization" — wraps the proven InsightVizPanel
       (chart_v5/table/sankey/heatmap/pie field-mapping + layout + insight_type).
       Resolves live output columns from the fact DA(s). Patches
       insight_type / viz_type / viz_config / layout / display_order. -->
  <InsightVizPanel
    v-model="viz"
    :output-columns="outputColumns"
  />
</template>

<script>
import axios from 'axios';
import InsightVizPanel from '@/components/Admin/MetricStudio/panels/InsightVizPanel.vue';

export default {
  name: 'InsightVizSection',
  components: { InsightVizPanel },
  props: {
    record: { type: Object, required: true },
    artifact: { type: Object, required: true },
    context: { type: Object, default: () => ({}) },
  },
  emits: ['patch'],
  data() {
    return {
      viz: {
        insight_type: this.record.insight_type || 'metric_insight',
        viz_type: this.record.viz_type || 'chart_v5',
        viz_config: this.record.viz_config || {},
        layout: this.record.layout || { width: 'full' },
        display_order: this.record.display_order || 0,
      },
      outputColumns: [],
      hydrating: true,
    };
  },
  computed: {
    steps() { return (this.record.studio_config || {}).steps || []; },
  },
  watch: {
    viz: { deep: true, handler() { this.emit(); } },
  },
  async mounted() {
    await this.loadColumns();
    this.$nextTick(() => { this.hydrating = false; });
  },
  methods: {
    async loadColumns() {
      const cols = [];
      const seen = new Set();
      for (const s of this.steps) {
        if (!s.workflow_id) continue;
        try {
          const { data } = await axios.get(`/api/metrics/workflow-columns/${s.workflow_id}/`);
          for (const c of data.columns || []) if (!seen.has(c)) { seen.add(c); cols.push(c); }
        } catch { /* ignore */ }
      }
      this.outputColumns = cols;
    },
    emit() {
      if (this.hydrating) return;
      this.$emit('patch', {
        insight_type: this.viz.insight_type,
        viz_type: this.viz.viz_type,
        viz_config: this.viz.viz_config || {},
        layout: this.viz.layout || { width: 'full' },
        display_order: this.viz.display_order || 0,
      });
    },
  },
};
</script>
